<template>
  <div class="middle cadfm-flexitem-stretched">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button @click="back" icon="back" bold :text="lang.button_Back" :tooltip="lang.button_Back"
            :disabled="backButtonStatus" />
          <action-button @click="save" icon="save" bold :text="lang.button_Save" :tooltip="lang.button_Save"
            :disabled="saveButtonStatus" />



        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <action-button v-show="!$parent.isVisibleLeft" @click="toggleLeftPanel" icon="show" bold
            :text="lang.button_Left" :tooltip="lang.button_Left" :disabled="false" />
          <action-button v-show="!$parent.isVisibleRight" @click="toggleRightPanel" icon="show" bold
            :text="lang.button_Right" :tooltip="lang.button_Right" :disabled="false" />

        </b-navbar-nav>
      </action-bar>
      <action-content>
        <Content :lang="lang.Content"></Content>
      </action-content>
    </action-panel>
  </div>
</template>

<script>
import ActionBar from "@/components/shared/ActionBar";
import ActionButton from "@/components/shared/ActionButton";
import ActionContent from "@/components/shared/ActionContent";
import ActionPanel from "@/components/shared/ActionPanel";

import Content from "@/components/ProjectManager/Views/ProjectDerive/Middle/Content/Content";

export default {
  name: "Middle",
  components: {
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    Content
  },
  props: {
    lang: Object
  },
  data() {
    return {
      saveButtonStatus: false,
      backButtonStatus: false,
      saving: false
    };
  },
  computed: {
    revisionId(){
      if (this.$route.query.source == "ProjectDetails"){
        return this.$route.query.revisionId;
      }      
      return this.$route.query.revisionId;
    },
    blockCreateOver1Level() {
      if (this.$store.getters.selectedTreeProjectItemObject.depth > 1) {
        this.saveButtonStatus = false;
        return true;
      } else {
        this.saveButtonStatus = true;
        return false;
      }
    },
  },
  created() {

  },
  watch: {
    blockCreateOver1Level: function () {

    }
  },
  methods: {
    save() {
      
        
      let vue = this;

      let trig = false;
      for (let i = 0, lei = this.$store.getters.propertyToSaving.length; i < lei; i++){
        

        if ((this.$store.getters.propertyToSaving[i].isRequiredOnRequest == true)&&(this.$store.getters.propertyToSaving[i].value == "")){
          trig = true;
          break;
        }
      }

      if (trig == true){
        let obj = {
          text: this.lang.alert_error_new_part_required,
          time: 15,
          type: "danger"
        }

        this.$store.dispatch("displayFooterAlert", obj);
      }else{

        

        let obj = {
          categoryId: this.$store.getters.selectedTreeProjectItemObject.categoryId,
          projectRevisionId: this.revisionId,
          values: this.$store.getters.propertyToSaving,
          
        }

        
        this.$store.dispatch("showLoader", { visible: true, text: "wait" });
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_deriveProject", obj)
        .then(function(result){

          console.log(result.data)

          vue.$store.dispatch("showLoader", { visible: false, text: "" });

          if (result.status == "OK"){

            if (result.data != null){
              vue.saving = true;

              const obj = {
                text: vue.lang.alert_success_derive,
                time: 10,
                type: "success"
              }

              vue.$store.dispatch("displayFooterAlert", obj);

              vue.toDetails(result.data);
            }else{

              const obj = {
                text: vue.lang.alert_error_derive + ".",
                time: 15,
                type: "danger"
              }

              vue.$store.dispatch("displayFooterAlert", obj);

            }

            


          }else{
            const obj = {
              text: vue.lang.alert_error_derive + ": " + result.message,
              time: 15,
              type: "danger"
            }

            vue.$store.dispatch("displayFooterAlert", obj);
          }


        })

      }


    },
    toDetails(goalObj){
      this.$store.dispatch("resetPropertyToSaving");

      this.$store.dispatch("deleteAllSelectedRows");

      let to = "/ProjectManager/ProjectDetails";
      
      

      const obj = {
          col___revisionId: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.projectId,
            userId: goalObj.userId,
            value: {
              display: goalObj.revisionId
            }
          },
          col___revision: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.projectId,
            value: {
              display: goalObj.revision
            }
          },
          col___status: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.projectId,
            value: {
              display: "pending"
            }
            
          },
          col___name: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.projectId,
            value: {
              display: goalObj.projectNumber
            }
            
          },
          col___image: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.projectId,
            value: {
              display: ""
            }
          },
          col___projectType: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.projectId,
            value: {
              display: ""
            }
          }
        }

        

      this.$store.dispatch("setSelectedRows", [obj]);
      
      this.$store.dispatch("setOuterData", true);

      this.$store.dispatch("editPropertiesForm", false);

      
      
    
            
      const query = {
        from: this.$route.path,
        to: to,
        
      }

      this.$router.push({ path: to, query: query });
    },
    back() {
      

      this.$store.dispatch("resetPropertyToSaving");

      if (this.saving) {
        
        const reloadObj = {
          status: true,
          name: "DataTableFilteredOnApiLibComponent"
        };
        this.$store.dispatch("reloadAfterActionComplex", reloadObj);
      }

      //#####################################################################
      let query = {};
      let to = "";
      
      if (this.$store.getters.routingData.length == 0) {
        if (this.$store.getters.sectionPrefix == "pm") {
          to = "/PartManager/PartTable";
        }
        if (this.$store.getters.sectionPrefix == "lm") {
          to = "/LibraryManager/LibraryTable";
        }
        if (this.$store.getters.sectionPrefix == "projm") {
          if (this.$route.path == "ProjectManager/ProjectBom") {
            to = "/ProjectManager/ProjectDetails";
          } else {
            to = "/ProjectManager/ProjectTable";
          }

        }


      } else {
        to = this.$store.getters.routingData[this.$store.getters.routingData.length - 1].from;
        if (this.$store.getters.routingData[this.$store.getters.routingData.length - 1].end == true) {
          if (this.$store.getters.sectionPrefix == "pm") {
            to = "/PartManager/PartTable";
          }
          if (this.$store.getters.sectionPrefix == "lm") {
            to = "/LibraryManager/LibraryTable";
          }
          if (this.$store.getters.sectionPrefix == "projm") {
            if (this.$route.path == "ProjectManager/ProjectBom") {
              to = "/ProjectManager/ProjectDetails";
            } else {
              to = "/ProjectManager/ProjectTable";
            }
          }

        }

        query = {
          from: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].to,
          to: to,
          end: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].end,
          revisionId: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceRevisionId,
          id: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceId
        }
        if (this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceType == "main") {
          query = {};
        } else if (this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceType == "details") {
          const goalObj = {
            to: to,
            revisionId: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceRevisionId,
            id: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].sourceId,
            selectedBomRow: [{ bomId: this.$store.getters.routingData[this.$store.getters.routingData.length - 1].bomId }],

          }
          this.selectRow(goalObj);
        }

        this.$store.commit("BACKROUTINGDATA");
      }

      // const query = {
      //   from: this.$route.path,
      //   to: to,

      // }

      this.$router.push({ path: to, query: query });
    },
    selectRow(goalObj) {
     


      this.$store.dispatch("projm_setSelectedBomRow", goalObj.selectedBomRow)

      let obj = {};

      if (goalObj.to == "/PartManager/PartDetails") {
        obj = {
          col___revisionId: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___revision: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___status: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }

          },
          col___name: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }

          },
          col___image: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }
          },

        }
      }

      if (goalObj.to == "/LibraryManager/LibraryDetails") {
        let id = goalObj.id;

        obj = {
          col___revisionId: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            userId: goalObj.userId,
            value: {
              display: goalObj.revisionId
            }
          },
          col___revision: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: goalObj.revision
            }
          },
          col___status: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }

          },
          col___name: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }

          },
          col___libraryType: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }

          },
          col___image: {
            revisionId: goalObj.revisionId,
            libraryId: id,
            value: {
              display: ""
            }
          },

        }
      }

      if (goalObj.to == "/ProjectManager/ProjectDetails") {
        obj = {
          col___revisionId: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___revision: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___status: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: ""
            }

          },
          col___name: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: ""
            }

          },
          col___image: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: ""
            }
          },

        }
      }




      this.$store.dispatch("deleteAllSelectedRows");
      this.$store.dispatch("setSelectedRows", [obj]);

      this.$store.dispatch("setOuterData", true);

      this.$store.dispatch("editPropertiesForm", false);
    },
    toggleRightPanel() {
      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;
    },
    toggleLeftPanel() {
      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;
    }
  }
};
</script>


<style scoped>
.middle {
  border-right: 1px solid #666;
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectDerive/Middle/Middle.vue